// extracted by mini-css-extract-plugin
export var errorIcon = "_lg-1";
export var nameLogo = "_lg-0";